export default __webpack_public_path__ + "static/media/whitePriceIcon.cbb47093.svg";